import { DateTime } from 'luxon';
import { observable, computed } from 'mobx';
import RootStore from 'stores/RootStore';

import { getDate, getLocalDateTime } from 'helpers/datetime';

import { BaseFormModel, isRequired } from 'stores/BaseForm';
import {
  StornoReportComponent,
  StornoReportReqParams,
} from 'stores/Report/types';

class StornoReportForm extends BaseFormModel {
  @observable
  @isRequired()
  period: [DateTime, DateTime | undefined] = [
    getLocalDateTime(),
    getLocalDateTime(),
  ];

  @observable
  component = StornoReportComponent.ALL;

  @computed
  get requestParams(): StornoReportReqParams {
    const [startDate, endDate] = this.period;

    return {
      from: getDate(startDate.toJSDate()),
      to: getDate(endDate!.toJSDate()),
      component: this.component,
    };
  }

  @computed
  get componentValues() {
    return Object.values(StornoReportComponent).map(component => ({
      value: component,
      label: RootStore.localization.formatMessage(
        `title.report.storno.component.${component}`,
      ),
    }));
  }
}

export default StornoReportForm;
